import { render, staticRenderFns } from "./zhuyinggoucheng.vue?vue&type=template&id=40d43c34&scoped=true&"
import script from "./zhuyinggoucheng.vue?vue&type=script&lang=js&"
export * from "./zhuyinggoucheng.vue?vue&type=script&lang=js&"
import style0 from "./zhuyinggoucheng.vue?vue&type=style&index=0&id=40d43c34&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40d43c34",
  null
  
)

export default component.exports